var _circle, _circle2, _circle3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgLoading = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 20 60 60",
  xmlSpace: "preserve",
  fill: "currentColor",
  width: "1em",
  height: "1em"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 50,
  r: 6
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  dur: "1s",
  values: "0;1;0",
  repeatCount: "indefinite",
  begin: 0.1
}))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 50,
  r: 6
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  dur: "1s",
  values: "0;1;0",
  repeatCount: "indefinite",
  begin: 0.2
}))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 50,
  r: 6
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  dur: "1s",
  values: "0;1;0",
  repeatCount: "indefinite",
  begin: 0.3
}))));

export default SvgLoading;